import { render, staticRenderFns } from "./rent.vue?vue&type=template&id=296fa094&scoped=true"
import script from "./rent.vue?vue&type=script&lang=js"
export * from "./rent.vue?vue&type=script&lang=js"
import style0 from "./rent.vue?vue&type=style&index=0&id=296fa094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296fa094",
  null
  
)

export default component.exports